<table class="lifecycle">
  <tr>
    <td>Started:</td>
    <td>
      {{ clientChore.startedAt | date: 'MM/dd/yyyy hh:mm a' }}
      <span>by {{ clientChore.submittedBy?.fullName }}</span>

      @if (clientChore.initiatedVia === clientChoreInitiatedVia.clientConfigurationUpdate) {
        <div>
          <small>(via config update)</small>
        </div>
      }
      @if (clientChore.initiatedVia === clientChoreInitiatedVia.clientUpdate) {
        <div>
          <small>(via client update)</small>
        </div>
      }
      @if (clientChore.initiatedVia === clientChoreInitiatedVia.patientInteractionLocationUpdate) {
        <div>
          <small>(via client location update)</small>
        </div>
      }
    </td>
  </tr>
  @if (clientChore.endedAt) {
    <tr>
      <td>Ended:</td>
      <td>{{ clientChore.endedAt | date: 'MM/dd/yyyy hh:mm a' }}</td>
    </tr>
  }
  @if (clientChore.reviewedAt) {
    <tr>
      <td>Reviewed:</td>
      <td>
        {{ clientChore.reviewedAt | date: 'MM/dd/yyyy hh:mm a' }}
        <span>by {{ clientChore.reviewedBy?.fullName }}</span>
      </td>
    </tr>
  }
  @if (clientChore.inactive) {
    <tr class="warning">
      <td></td>
      <td>Last update {{ clientChore.lastUpdatedInWords }}</td>
    </tr>
  }

</table>
